export const GET_SHOP = 'GET_SHOP'  //获取门店
export const CHANGE_SHOP = 'CHANGE_SHOP'  //切换门店


// WEBPACK FOOTER //
// ./src/store/mutations.js